module.exports = __webpack_public_path__ + "img/Class-A-Mobile.6f5c7712.jpg";